import { IEnvironmentState } from "../model"

export function getDefaultEnvironmentState(): IEnvironmentState {
  return {
    list: [],
    tree: [],
    environmentById: {}
  }
}
